const expiryDays = 0;

const local = {
  search: {
    ELASTIC_SEARCH_HOST: 'http://localhost:8080',
    LOT_SEARCH_HOST: 'https://dev.lrsnative.com.au/hlrv/lotsearch/search',
    INDEX_NAME: 'hlrv/documents'
  },
  image: {
    IMAGE_HOST:
      'http://internal-dev-h-appli-b01pk18rxqbk-942308610.ap-southeast-2.elb.amazonaws.com/hlrv/iiif/2/'
  },
  publicKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnN98+Z8i3NFs9VL1lzWf\n' +
    'ar1zuRk/VA7binizLp0B+CfR+ai9uYrYYkSy4BgfnJgluJMSj/rVBS9UWbVz1Jxf\n' +
    '5tA5plYmscH25eDRwGo6ZHH4y7+vjMTOIw0aSHXiwJu+n2wAyw2wcDkuTIETMTzQ\n' +
    'gQA+PGYoEkaYg7z8NJjemCJlQ6+k/AfFoOshYqFPs0v5Q2u6Ijctk4HpkmwjStbM\n' +
    '+vdmfL2venFiHenlVpu2L9jrT8u2FK5+812fxPu23YC88s7/B7wcjYNORBOKyrvb\n' +
    'NlSDAmZkZiOc3Aj6ar0jNNMbsQxpXB9hCWidkwgJIylrDyKgIRPWyFugyr6CKnF0\n' +
    'BwIDAQAB\n' +
    '-----END PUBLIC KEY-----',
  restrictedCollectionIds: '54, 31, 55',
  printAPI: 'https://dev.lrsnative.com.au/hlrv/print/resize',
  printRestrictionAPI: 'https://dev.lrsnative.com.au/hlrv/print/checkRestriction',
  expiryDays: expiryDays
};

const dev = {
  search: {
    ELASTIC_SEARCH_HOST: 'https://dev.lrsnative.com.au',
    LOT_SEARCH_HOST: 'https://dev.lrsnative.com.au/hlrv/lotsearch/search',
    INDEX_NAME: 'hlrv/documents'
  },
  image: {
    IMAGE_HOST:
      'https://dev.lrsnative.com.au/hlrv/iiif/2/'
  },
  publicKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnN98+Z8i3NFs9VL1lzWf\n' +
    'ar1zuRk/VA7binizLp0B+CfR+ai9uYrYYkSy4BgfnJgluJMSj/rVBS9UWbVz1Jxf\n' +
    '5tA5plYmscH25eDRwGo6ZHH4y7+vjMTOIw0aSHXiwJu+n2wAyw2wcDkuTIETMTzQ\n' +
    'gQA+PGYoEkaYg7z8NJjemCJlQ6+k/AfFoOshYqFPs0v5Q2u6Ijctk4HpkmwjStbM\n' +
    '+vdmfL2venFiHenlVpu2L9jrT8u2FK5+812fxPu23YC88s7/B7wcjYNORBOKyrvb\n' +
    'NlSDAmZkZiOc3Aj6ar0jNNMbsQxpXB9hCWidkwgJIylrDyKgIRPWyFugyr6CKnF0\n' +
    'BwIDAQAB\n' +
    '-----END PUBLIC KEY-----',
  restrictedCollectionIds: '54, 31, 55',
  printAPI: 'https://dev.lrsnative.com.au/hlrv/print/resize',
  printRestrictionAPI: 'https://dev.lrsnative.com.au/hlrv/print/checkRestriction',
  expiryDays: expiryDays
};

const uat = {
  search: {
    ELASTIC_SEARCH_HOST: 'https://uat.lrsnative.com.au',
    LOT_SEARCH_HOST: 'https://uat.lrsnative.com.au/hlrv/lotsearch/search',
    INDEX_NAME: 'hlrv/documents'
  },
  image: {
    IMAGE_HOST:
      'https://uat.lrsnative.com.au/hlrv/iiif/2/'
  },
  publicKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm8Wacr2g1HWJ+YQI/vXx\n' +
    'WgXf8WUzL5gl5oJ/1t42IgIxhcEaUu9UL3/16beVzN/FgNPFDGng4GaHbfpZslrO\n' +
    'Le/Kxc8A7VUueT9E4isl95vX50aQldx2J5FBCCrBZOlJUg6Q8Wy+KbNNXosqHLJg\n' +
    'Bo/N7M6hgfKkNRFhSkA+YsuztP+dnRJEtRV8+CccXWlCc+nukJ8lwt22SiXHdQVT\n' +
    'mDo80cLnPaKi5annPWu+KoFX/uR3f4PHI11hwzRENG8/O14gJR0LHuUXSX6uzpu8\n' +
    'I0cVGmDfAYVmqpAmPJgiv3VDmyN08tfcvKlBqeGbcBMMsFk2rKp8jl6l7rH5YI9/\n' +
    'GwIDAQAB\n' +
    '-----END PUBLIC KEY-----\n',
  restrictedCollectionIds: '54, 31, 55',
  printAPI: 'https://uat.lrsnative.com.au/hlrv/print/resize',
  printRestrictionAPI: 'https://uat.lrsnative.com.au/hlrv/print/checkRestriction',
  expiryDays: expiryDays
};

const prod = {
  search: {
    ELASTIC_SEARCH_HOST: 'https://api.lrsnative.com.au',
    LOT_SEARCH_HOST: 'https://api.lrsnative.com.au/hlrv/lotsearch/search',
    INDEX_NAME: 'hlrv/documents'
  },
  image: {
    IMAGE_HOST:
      'https://api.lrsnative.com.au/hlrv/iiif/2/'
  },
  publicKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlkdRbJk9mewZrPpGXUA5\n' +
    '1gBwvmH0MwX/6Ug/kGjRTbKhy5fEoIjz35/9cno60DHlkunGp0d9ns0PUwZ48VHb\n' +
    '9nYVMjuK3aFgbDRhk1n17PpmPykj44E0W2jwxr3QauWAvuSQE+ykQKsqqt8pXUGS\n' +
    'ZLCep/5e+8vGHI2FtyjlBp/WnBgqq/bO/Z4xuEVP4BZpleUWPJtkLS7MhXpt3mth\n' +
    'HXIF59jAVKNmp/CsEqsE5K/4n9SEfpERScFFWdtn0yK8xji0LlUHwz4+HlCljlg+\n' +
    'OYYwMR0V+7u6xG1pXhi+IqwU3liIiwQDwucZGust/pbqcEltxMpDWDw74ql46QE9\n' +
    '/wIDAQAB\n' +
    '-----END PUBLIC KEY-----\n',
  restrictedCollectionIds: '54, 31, 55',
  printAPI: 'https://api.lrsnative.com.au/hlrv/print/resize',
  printRestrictionAPI: 'https://api.lrsnative.com.au/hlrv/print/checkRestriction',
  expiryDays: 7
};

// Default to local if not set
const config = getEnvironment();

export default {
  ...config
};

// Check envrionment variable for config
function getEnvironment(): any {
  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      return prod;
    case 'dev':
      return dev;
    case 'local':
      return local;
    case 'uat':
      return uat;
    default:
      return local;
  }
}



// WEBPACK FOOTER //
// ./src/config.tsx